import * as moment from 'moment-timezone';

import { LoggerFactory, ILogger } from './Log/index';
import { getTimeZone } from '../../common/getTimezone';

export class TimeZoneHelper {
    private _logger: ILogger;

    constructor() {
        this._logger = LoggerFactory.getLogger('Helpers/TimeZoneHelper');
    }

    getOlsonName(timeZone: string): string {
        let olsonName = 'Etc/GMT';
        try {
            if (timeZone == null || timeZone === 'UTC') {
                olsonName = 'Etc/GMT';
            } else if (timeZone === 'Local') {
                olsonName = getTimeZone();
            } else {
                olsonName = timeZone;
            }
        } catch (e) {
            this._logger.error(e);
        }
        return olsonName;
    }

    getOffset(dateTime, timeZone): number {
        let offset = 0;
        if (timeZone === 'Etc/GMT') {
            offset = 0;
        } else {
            try {
                //TODO find a way to get types on timezone
                offset = (moment).tz.zone(this.getOlsonName(timeZone)).utcOffset(0);
            } catch (e) {
                console.error(e);
            }
        }
        return offset;
    }
}